import React, { useEffect, useState } from 'react';
import { ArrowLeft, CalendarHeart } from 'lucide-react';
import { EventRow } from '../components/EventRow';
import { EventInquiryModal } from '../components/EventInquiryModal';
import { EventSignupModal } from '../components/EventSignupModal';
import { BakeryEvent } from '../types/event';
import { events } from '../data/events';
interface EventsProps {
  onBack: () => void;
}
export function Events({
  onBack
}: EventsProps) {
  const [showInquiry, setShowInquiry] = useState(false);
  const [signupEvent, setSignupEvent] = useState<BakeryEvent | null>(null);
  useEffect(() => {
    const previous = document.title;
    document.title = 'Event & Happenings – Top Notch Bakery';
    return () => {
      document.title = previous;
    };
  }, []);
  const today = new Date().toISOString().slice(0, 10);
  const upcoming = events.filter(e => e.date >= today).sort((a, b) => a.date.localeCompare(b.date));
  return <div className="w-full max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-8 md:pt-12 pb-24" data-id="element-1179" data-mp="1wsd71l3rrjek">
      <button onClick={onBack} className="inline-flex items-center gap-2 text-sm font-medium text-[#1A1A1A]/60 hover:text-[#7C8062] transition-colors" data-id="element-1180" data-mp="1c3ekl1xh8lnn">
        <ArrowLeft className="w-4 h-4" aria-hidden="true" data-id="element-1181" data-mp="1m3f5utewpbuh" />
        Till startsidan
      </button>

      <header className="mt-10 md:mt-14 mb-12 md:mb-16 max-w-2xl" data-id="element-1182" data-mp="1h3sruhr97rkm">
        <p className="text-sm font-medium text-[#C4993D] mb-3" data-id="element-1183" data-mp="tehtf6xdm99n">
          Halloween · vecka 44 · 26 oktober – 1 november
        </p>
        <h1 className="font-serif text-5xl md:text-6xl text-[#1A1A1A] leading-[1.05] mb-5" data-id="element-1184" data-mp="ogg8shkay1w2">
          Event & Happenings
        </h1>
        <p className="text-lg text-[#1A1A1A]/75 leading-relaxed" data-id="element-1185" data-mp="135m61zzkxi1b">
          En hel vecka av spökligt goda smaker, löpning, disko och brunch på
          Toppen. Boka din plats direkt här på sidan – tider som ännu inte är
          satta meddelas här.
        </p>
      </header>

      <section aria-labelledby="upcoming-heading" data-id="element-1186" data-mp="5o48s1h4fcp3">
        <h2 id="upcoming-heading" className="sr-only" data-id="element-1187" data-mp="vd1bblesjihj">
          Kommande event
        </h2>
        {upcoming.length > 0 ? <div className="border-b border-[#7C8062]/20" data-id="element-1188" data-mp="zduyudobmv9w">
            {upcoming.map(event => <EventRow key={event.id} event={event} onSignup={setSignupEvent} data-id="element-1189" data-mp="14538natkcinl" />)}
          </div> : <div className="py-16 border-y border-[#7C8062]/20 text-center" data-id="element-1190" data-mp="ceowbj177ee1">
            <CalendarHeart className="w-10 h-10 text-[#7C8062]/50 mx-auto mb-4" aria-hidden="true" data-id="element-1191" data-mp="gfsdq9yw9ihd" />
            <p className="font-serif text-2xl text-[#1A1A1A] mb-2" data-id="element-1192" data-mp="ldttom10x1om">
              Inga planerade event just nu
            </p>
            <p className="text-[#1A1A1A]/60" data-id="element-1193" data-mp="qf9gaiiung94">
              Följ oss på Instagram så missar du inget som är på gång.
            </p>
          </div>}
      </section>

      <section className="mt-16 md:mt-24 grid md:grid-cols-[1fr_auto] gap-6 md:gap-12 items-center bg-[#3A3A2E] text-[#F2EDE4] rounded-2xl p-8 md:p-12" data-id="element-1194" data-mp="21s28fufjy6pp">
        <div data-id="element-1195" data-mp="3hc2sx2g46e11">
          <h2 className="font-serif text-3xl md:text-4xl mb-3" data-id="element-1196" data-mp="3hccm0ywgh1ay">
            Vill du ha ett eget event hos oss?
          </h2>
          <p className="text-[#F2EDE4]/75 leading-relaxed max-w-xl" data-id="element-1197" data-mp="3ckb16ol8229b">
            Vi tar emot privata kurser, provningar och kvällar för företag och
            sällskap. Berätta vad du har i åtanke så återkommer vi.
          </p>
        </div>
        <button onClick={() => setShowInquiry(true)} className="inline-flex justify-center items-center px-7 py-3.5 bg-[#F2EDE4] text-[#1A1A1A] rounded-full text-sm font-medium hover:bg-white transition-colors whitespace-nowrap" data-id="element-1198" data-mp="33ilc3petbfep">
          Hör av dig
        </button>
      </section>

      {showInquiry && <EventInquiryModal onClose={() => setShowInquiry(false)} data-id="element-1199" data-mp="rvn757rc6hbj" />}

      {signupEvent && <EventSignupModal event={signupEvent} onClose={() => setSignupEvent(null)} data-id="element-1200" data-mp="mvsjdd2uy7up" />}
    </div>;
}